<template>
    <div class="signup-buttons">
        <a 
		href="#" 
		class="google-signup" 
		data-qa="guestLoginButton"
		@click.prevent="$bvModal.show('guest-modal')">
            Checkout as Guest
        </a>
        <b-modal 
          id="guest-modal" 
          hide-footer
          title="Checkout as Guest"
          >
          <div>
			<p>{{ $t('addEmailDisclaimer') }}</p>
			<br/>
            <div class="form-control">
              <input 
                v-model="email" 
                type="email" 
                name="email" 
                :placeholder="$t('email')"
                value v-on="$listeners" 
                @blur="$v.email.$touch()" 
                v-on:input="resetErrorMessage"
                :class="{ error: $v.email.$error }" >
              <i class="fas fa-envelope"></i>
            </div>
            <!--error message -->
            <template v-if="$v.email.$error">
              <div v-if="!$v.email.email" class="errorMessage">
                {{ $t('emailValid') }}
              </div>
              <div v-if="!$v.email.required" class="errorMessage">
                {{ $t('emailReq') }}
              </div>
            </template>
            <br/>
            <p><button class="login-btn" :disabled="$v.$invalid" sytle="text-transform: uppercase;" @click="loginAsGuest()">{{ $t('proceed') }}</button></p>
          </div>
        </b-modal>
        <!-- <a href="#" class="facebook-signup" @click.prevent="loginWithFacebook">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="#3578E5"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>
            Facebook
        </a> -->
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'


export default {
  name: 'login_signup_social',
  data() {
    return {
      email: ''
    }
  },
  validations: {
    email: {
      required,
      email,
    }
  },
  mounted () {
    // initFbsdk()
  },
  methods: {
    resetErrorMessage() {
      if (this.error) this.error = null
    },
    async loginAsGuest () {
      const response = await this.$store.dispatch('loginGuest', { email: this.email })
      this.$bvModal.hide('guest-modal')
      this.$emit('login-response', response)
    }
  }
}
</script>

<style lang="css" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-decoration: none;
}

#guest-modal .modal-header .close {
    padding: 1rem 1rem;
    margin: 0 !important;
    position: absolute !important;
}

/* #guest-modal .modal-header .close {
    padding: 1rem 1rem;
    position: absolute;
} */

.signup-buttons {
    margin-top: 15px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    position: relative;
    width: 100%;
}

.facebook-signup, .google-signup {
    color: #444 !important;
    background: white;
    border-radius: 5px;
    border: thin solid #888;
    box-shadow: 1px 1px 1px grey;
    white-space: nowrap;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: inline-block;
    margin-top: 0;
    width: 100%;
    padding: 15px;
    text-align: center;
    position: inherit;
}

.login-btn{
  color: var(--primary) !important;
  border: 1px solid var(--primary);
  background: none;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
}

.login-btn:hover{
  background: var(--primary);
  color: var(--bright) !important;
}

form {
    width         : 100%;
    max-width: 400px;
    display       : flex;
    flex-direction: column;
}

.form-control {
    width        : 100%;
    position     : relative;
    margin-bottom: 24px;
    border: none !important;
}

input {
    width         : 100%;
    background    : #e6e6e6;
    color         : #333;
    letter-spacing: 0.5px;
    padding       : 14px 64px;
}

input~i {
    position  : absolute;
    left      : 22px;
    top       : 80%;
    transform : translateY(-50%);
    color     : var(--gray);
    transition: color 0.4s;
    font-size: 1.3em;
}

input:focus~i {
    color: #0E484B;
}

button.action {
    color           : #fff;
    padding         : 14px 64px;
    margin          : 32px auto;
    text-transform  : uppercase;
    letter-spacing  : 2px;
    font-weight     : bold;
    background-color: var(--primary);
    background: var(--primary);
    cursor          : pointer;
    transition      : opacity 0.4s;
}

button.action:hover {
    opacity: 0.9;
}

input,
button {
    border       : none;
    outline      : none;
    border-radius: 30px;
    font-size    : 1.1em;
}

.errorMessage {
  margin-bottom: 0.2em;
  color: var(--primaryDark);
}

.eyeIcon {
  position: absolute;
  top: 20px;
  right: 20px;
}
</style>
